import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './WorkDetails.css';
import WorkDetailsTop from '../components/WorkDetailsTop';
import WorkDetailsOverview from '../components/WorkDetailsOverview';
import WorkDetailsProcess from '../components/WorkDetailsProcess';
import data from '../data.json';

const WorkDetails = () => {
    const { id } = useParams(); // Extraire l'ID de l'URL
    const workItemId = parseInt(id); // Convertir l'ID en entier
    const workItem = data.work.find(item => item.id === workItemId); // Rechercher le projet par ID dans data.json

    useEffect(() => {
        window.scrollTo(0, 0); // Faire défiler vers le haut lorsque le composant est monté
    }, []); // [] comme dépendance pour exécuter une seule fois après le montage initial

    if (!workItem) {
        return <div>Work item not found.</div>;
    }

    return (
        <div className="work-details">
            <div className="work-details-top-container">
            <WorkDetailsTop
                image={workItem.image}
                title={workItem.title}
                shortdescription={workItem.shortdescription}
            />
            </div>
            <WorkDetailsOverview
                description={workItem.longdescription}
                company={workItem.company}
                companydescription={workItem.companydescription}
                companyjob={workItem.companyjob}
                start={workItem.start}
                end={workItem.end}
                team={workItem.team}
                tasks={workItem.tasks}
                
            />
            <WorkDetailsProcess workId={workItemId} />
        </div>
    );
};

export default WorkDetails;
